<template>
  <div id="app" class="container">
    <transition :name="transitionName">
       <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "App",
  data(){
      return{
        transitionName:""
      }
    },
  created(){
    
  },
  watch:{
    "$route"(to,from){
       let toName = to.name
        const toIndex = to.meta.index;
        const fromIndex = from.meta.index
        this.transitionName = toIndex < fromIndex ? 'slide-right' : 'slide-left'
    }
  }
};
</script>

<style>
*{
  -webkit-tap-highlight-color:rgba(255, 255, 255, 0);
-webkit-tap-highlight-color:transparent;}
.container{
  width: 100vw;
  height: 100vh;
}
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  font-family: PingFangSC-Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-top: 0;
  font-weight: 400;
}
.icon {
  width: 0.7467rem;
	height: 0.7467rem;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.mint-indexlist-nav {
  display: none;
}
.mint-cell-wrapper{
  font-size: 0.35rem;
  width: 9.25rem;
  margin-left:0.75rem;
  border-bottom: 0.025rem solid #dddddd;
  padding: 0.38rem 0 0.38rem 0;
}
.mint-radiolist-label{
  margin-left:0.41rem;
}
.mint-radio-core{
  margin-left: -0.65rem;
  width:16px;
  height: 16px;
}
.mint-radio-core::after {
    top: 3px;
    left: 3px;
    position: absolute;
    width: 8px;
    height: 8px;
}
.slide-right-enter-active {
  transition: all .3s ease;
  -moz-transition: all .3s ease;
  -o-transition: all .3s ease;
  -webkit-transition: all .3s ease;
}
.slide-right-enter, .slide-right-leave-to {
  transform: translateX(-750px);
  -ms-transform: translateX(-750px);
  -o-transform: translateX(-750px);
  -webkit-transform: translateX(-750px);
}
.slide-left-enter-active {
  transition: all .3s ease;
  -moz-transition: all .3s ease;
  -o-transition: all .3s ease;
  -webkit-transition: all .3s ease;
}
.slide-left-enter, .slide-left-leave-to {
  transform: translateX(750px);
  -ms-transform: translateX(750px);
  -o-transform: translateX(750px);
  -webkit-transform: translateX(750px);
}
</style>



// WEBPACK FOOTER //
// src/App.vue